import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_SUBPRACTICE_INFO = 'UPDATE_SUBPRACTICE_INFO';
export const UPDATE_SUBPRACTICE_INFO_SUCCESS =
  'UPDATE_SUBPRACTICE_INFO_SUCCESS';
export const UPDATE_SUBPRACTICE_INFO_FAILURE =
  'UPDATE_SUBPRACTICE_INFO_FAILURE';

// Action Creators
export const updateSubpracticeInfo = () => ({
  type: UPDATE_SUBPRACTICE_INFO,
});

export const updateSubpracticeInfoSuccess = (users) => ({
  type: UPDATE_SUBPRACTICE_INFO_SUCCESS,
  payload: users,
});

export const updateSubpracticeInfoFailure = (error) => ({
  type: UPDATE_SUBPRACTICE_INFO_FAILURE,
  payload: error,
});

// Thunk Function

export const updateSubpracticeInfoCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(updateSubpracticeInfo());
    try {
      const response = await putMethodWithToken(
        url.subpracticeInfo +
          data?.doctor_id +
          '/' +
          data?.doc_subpractice_id +
          '/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateSubpracticeInfoSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updateSubpracticeInfoFailure('error'));
      }
    } catch (error) {
      dispatch(updateSubpracticeInfoFailure(error));
    }
  };
};
